
<div mdc-ripple style="height: 100%; width: 100%; text-align: center; align-content: center; font-size: 8pt; ">
VizRep
</div>
